export default __webpack_public_path__ + "static/media/runner.2dd99e16.svg";